import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

interface NavButtonProps extends ButtonProps {
  active?: boolean;
  fullWidth?: boolean;
}

export const NavButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'fullWidth',
})<NavButtonProps>(({ theme, active, fullWidth }) => ({
  fontWeight: active ? 600 : 500,
  fontSize: '1.05rem',
  textTransform: 'none',
  position: 'relative',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  backgroundColor: 'transparent',
  width: fullWidth ? '100%' : 'auto',
  justifyContent: fullWidth ? 'flex-start' : 'center',
  padding: fullWidth ? theme.spacing(1.5, 2) : theme.spacing(1),
  '&::after': {
    content: '""',
    position: 'absolute',
    width: active ? '100%' : '0%',
    height: '2px',
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.primary.main,
    transition: 'width 0.2s ease-in-out',
  },
  '&:hover::after': {
    width: '100%',
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '1.1rem',
    padding: theme.spacing(1.5, 2),
  },
})); 